import { render, staticRenderFns } from "./MassCopyConfirm.vue?vue&type=template&id=3623b39d"
import script from "./MassCopyConfirm.vue?vue&type=script&lang=js"
export * from "./MassCopyConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports